import * as Response from './response'
import { CompanyPreferencesData } from './types'

export function convertCompanyPreferences(
  response: Response.Company
): CompanyPreferencesData {
  const companyPreferences = {
    showCustomFilters: response.company_preferences.show_custom_filters,
    enableCustomEvents:
      response.company_preferences.enable_custom_events ?? false,
    enableEmpRecognitionViaGoldStars:
      response.company_preferences.enable_emp_recognition_via_gold_stars ??
      false,
    enableUrgentMessage:
      response.company_preferences.enable_urgent_message ?? false,
    dailyPayEnabled: response.company_preferences.enable_dailypay ?? false,
  }

  return companyPreferences
}
